import { Spinner } from '@leroy-merlin-br/backyard-react-ui'

import * as S from './styled'

function ModalSkeleton () {
  return (
    <S.Wrapper>
      <Spinner />
    </S.Wrapper>
  )
}

export default ModalSkeleton
